import axiosConfig from './axiosConfig';
import { useQuery } from '@tanstack/react-query';
import { exportData } from './export';


// Export aggregated report as XLSX
export const exportAggregatedReportXLSX = async (queryParams = {}) => {
    return exportData('reports/aggregate/export/xlsx', 'dashboardReports', queryParams);
};

export const useAggregatedReport = (queryParams, options = {}) => useQuery({
    queryKey: ['aggregatedReport', queryParams],
    queryFn: async () => {
        const response = await axiosConfig.get('reports/aggregate', { params: queryParams });
        return response.data?.data;
    },
    ...options,
});

export const useVendorPerformanceReport = (queryParams, options = {}) => useQuery({
    queryKey: ['vendorPerformance', queryParams],
    queryFn: async () => {
        const response = await axiosConfig.get('reports/vendor-performance', { params: queryParams });
        return response.data?.data;
    },
    ...options,
});
